import React from 'react';

type CardProps = {
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export default function Card({ title, subtitle, footer, children, className = '' }: CardProps) {
  return (
    <section
      className={`rounded-2xl border p-5 backdrop-blur ${className}`}
      style={{
        backgroundColor: 'var(--color-bg-overlay)',
        borderColor: 'var(--color-border-primary)',
        color: 'var(--color-text-primary)',
      }}
    >
      {(title || subtitle) && (
        <header className='mb-3'>
          {title && (
            <h3 
              className='text-lg font-bold'
              style={{ color: 'var(--color-text-primary)' }}
            >
              {title}
            </h3>
          )}
          {subtitle && (
            <p 
              className='text-sm'
              style={{ color: 'var(--color-text-secondary)' }}
            >
              {subtitle}
            </p>
          )}
        </header>
      )}
      <div>{children}</div>
      {footer && (
        <div 
          className='mt-4 border-t pt-4'
          style={{ borderColor: 'var(--color-border-primary)' }}
        >
          {footer}
        </div>
      )}
    </section>
  );
}
